<template>
  <div class="home-page page-container">
    <home-carousel />

    <div v-if="featuredSpeakers">
      <h4 class="text-center text-sm-left pt-1 homepage-shiurim-title">
        {{ $t('featuredMagidShiur') }}
      </h4>
      <magidei-list type="torah" :magidei-shiur="featuredSpeakers"></magidei-list>
    </div>

    <div v-if="!isRTL" class="mt-5">
      <picture>
        <source media="(min-width:1280px)" srcset="/static/img/home/hebrew-banner-desktop.jpg" />
        <source media="(min-width:768px)" srcset="/static/img/home/hebrew-banner.jpg" />
        <img src="/static/img/home/hebrew-mobile-banner.jpg" alt="Sponsor" class="banner-full mt-3 mb-5" />
      </picture>
    </div>

    <div v-if="$store.state.api.categories.length > 0">
      <CategoryListSingle
        :showFilters="{ speaker: true }"
        :showPagination="false"
        :key="cat.id"
        :singleCategoryPage="false"
        v-for="cat in $store.state.api.categories"
        :slug="cat.url_key"
        :perCategory="15"
        class="mb-4"
      />
    </div>
    <div>
      <TopicCategoryList />
    </div>
  </div>
</template>
<script>
import MagideiShiurComponent from './magideiShiur/MagideiShiurList.vue';
import MasechtosComponent from './Masechtos.vue';
import MagideiListComponent from './magideiShiur/magideiList.vue';
import HomeCarousel from './partials/HomeCarousel.vue';
import CategoryListSingle from './torahShiurim/CategoryListSingle';
import { mapState } from 'vuex';
import topicCategoryList from './topics/topicCategoryList';

export default {
  components: {
    MagideiShiur: MagideiShiurComponent,
    Masechtos: MasechtosComponent,
    MagideiList: MagideiListComponent,
    HomeCarousel: HomeCarousel,
    CategoryListSingle: CategoryListSingle,
    TopicCategoryList: topicCategoryList,
  },
  i18nOptions: {
    namespaces: 'pages',
    keyPrefix: 'homepage',
  },
  data: function () {
    return {
      categoryShiurim: null,
      dafLink: '#',
      featuredSpeakers: null,
    };
  },
  created: function () {
    this.getSpeakerData('torah');
    this.$store.dispatch('api/loadCategories');
  },
  methods: {
    getSpeakerData: function () {
      if (Object.keys(this.$store.state.api.featuredSpeakers).length === 0) {
        this.$store.dispatch('api/loadFeaturedSpeakers').then(() => {
          this.featuredSpeakers = this.$store.state.api.featuredSpeakers;
        });
      } else {
        this.featuredSpeakers = this.$store.state.api.featuredSpeakers;
      }
    },
  },
};
</script>
<style lang="scss">
.banner-full {
  width: 100%;
}
.full-width-content {
  margin: 0 -5%;
  @media (min-width: 768px) and (max-width: 992px) {
    margin: 0 -4%;
  }
  @media (max-width: 768px) {
    margin: 0 -3%;
  }
}
.content {
  min-width: 100%;
  min-height: 500px;
  max-height: 500px;
}
</style>
<style lang="scss" scoped>
.btn-outline-secondary {
  &:hover {
    background: $secondary;
    color: $dark-blue;
    border-color: $secondary;
  }
}
</style>
